<template>
  <div>
    <div style="text-align: center" class="not-printable">
      <v-btn @click="printReport()" tile color="primary">
        <v-icon left> mdi-printer </v-icon>
        طباعة
      </v-btn>
    </div>
    <v-container class="container" fluid>
      <div>
        <h3 style="text-align: center">من تاريخ {{ dates[0] }} الى تاريخ {{ dates[1] }}</h3>
      </div>
      <div><h3>الايرادات</h3></div>
      <table style="width: 100%" class="table-data" border="1">
        <tr>
          <th>التسلسل</th>
          <th>رقم الوصل</th>
          <th>تاريخ الوصل</th>
          <th colspan="2">نوع السند</th>
          <th>من صندوق</th>
          <th>نوع القبض</th>
          <th>المبلغ</th>
          <th colspan="4">الملاحظات</th>
        </tr>
        <tr v-for="(item, index) in data.receipt" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.idReceipt }}</td>
          <td>{{ item.receiptDateFormat }}</td>
          <td colspan="2">{{ item.isInternal == 1 ? "قبض داخلي" : item.typeName }}</td>
          <td>{{ item.employeeName }}</td>
          <td>{{ boxName.find((box) => box.id == item.idBox)?.name }}</td>
          <td>
            {{
              item.amount.toLocaleString("en-US")
            }}
          </td>
          <td colspan="4">{{ item.notes }}</td>
        </tr>
      </table>
      <h5>
        مجموع الايرادات :
        {{
          data.receipt
            .filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 36 && data.boxId != 21)
            .reduce((n, { amount }) => n + amount, 0)
            .toLocaleString("en-US")
        }}
      </h5>
    </v-container>

    <v-container class="container" fluid>
      <div><h3>المصروفات</h3></div>
      <table style="width: 100%" class="table-data" border="1">
        <tr>
          <th>التسلسل</th>
          <th>رقم الوصل</th>
          <th>تاريخ الوصل</th>
          <th colspan="2">نوع السند</th>
          <th>المبلغ</th>
          <th colspan="4">الملاحظات</th>
        </tr>
        <tr v-for="(item, index) in data.expenses" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.idExpenses }}</td>
          <td>{{ item.expensesDateFormat }}</td>
          <td colspan="2">{{ item.typeName }}</td>
          <td>
            ,
            {{
              item.amount.toLocaleString("en-US")
            }}
          </td>
          <td colspan="4">{{ item.notes }}</td>
        </tr>
      </table>

      <h5>
        مجموع المصروفات :
        {{
          data.expenses
            .filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 14 && data.boxId != 21)
            .reduce((n, { amount }) => n + amount, 0)
            .toLocaleString("en-US")
        }}
      </h5>
    </v-container>

    <!-- <h4 style="padding: 10px">
        الرصيد :
        {{
          (data.totalReceipt - data.totalExpenses).toLocaleString("en-US", {
            style: "currency",
            
          })
        }}
      </h4>
      <v-divider></v-divider>

      <v-container class="container" fluid>
        <v-card elevation="6">
          <v-card-title>
            <v-row>
              <v-col cols="10">
                <h3>المقبوضات</h3>
              </v-col>
              <v-col cols="2" style="text-align: left" v-if="showExport">
                <v-btn icon @click="exportExcel()">
                  <v-icon color="primary"> mdi-microsoft-excel </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table :headers="receiptHeaders" :items="data.receipt" :items-per-page="10" item-key="idReceipt" class="table-content">
            <template v-slot:[`item.index`]="{ index }">
              <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
            </template>
            <template v-slot:[`item.gender`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.gender ? "انثى" : "ذكر" }}
              </h4>
            </template>

            <template v-slot:[`item.studyType`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.studyType ? "مسائي" : "صباحي" }}
              </h4>
            </template>
            <template v-slot:[`item.studentLevel`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.studentLevel.level | setLevel }}
              </h4>
            </template>

            <template v-slot:[`item.amount`]="{ item }">
              <p style="padding: 0 3px">
                {{
                  item.amount.toLocaleString("en-US", {
                    style: "currency",
                    
                  })
                }}
              </p>
            </template>

            <template v-slot:[`item.type`]="{ item }">
              <p style="padding: 0 3px">{{ item.isInternal == 1 ? "قبض داخلي" : item.typeName }}</p>
            </template>
          </v-data-table>
          <h3 style="padding: 10px">
            المجموع :
            {{
              data.totalReceipt.toLocaleString("en-US", {
                style: "currency",
                
              })
            }}
          </h3>
        </v-card>
      </v-container>

      <v-container class="container" fluid>
        <v-card elevation="6">
          <v-card-title>
            <v-row>
              <v-col cols="10">
                <h3>المصروفات</h3>
              </v-col>
              <v-col cols="2" style="text-align: left" v-if="showExport">
                <v-btn icon @click="exportExcel()">
                  <v-icon color="primary"> mdi-microsoft-excel </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table :headers="headers" :items="data.expenses" :items-per-page="10" item-key="idExpenses" class="table-content">
            <template v-slot:[`item.index`]="{ index }">
              <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
            </template>
            <template v-slot:[`item.gender`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.gender ? "انثى" : "ذكر" }}
              </h4>
            </template>

            <template v-slot:[`item.studyType`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.studyType ? "مسائي" : "صباحي" }}
              </h4>
            </template>
            <template v-slot:[`item.studentLevel`]="{ item }">
              <h4 style="padding: 0 3px">
                {{ item.studentLevel.level | setLevel }}
              </h4>
            </template>

            <template v-slot:[`item.amount`]="{ item }">
              <p style="padding: 0 3px">
                {{
                  item.amount.toLocaleString("en-US", {
                    style: "currency",
                    
                  })
                }}
              </p>
            </template>

            <template v-slot:[`item.type`]="{ item }">
              <p style="padding: 0 3px">{{ item.isInternal == 1 ? "قبض داخلي" : item.typeName }}</p>
            </template>
          </v-data-table>
          <h3 style="padding: 10px">
            المجموع :
            {{
              data.totalExpenses.toLocaleString("en-US", {
                style: "currency",
                
              })
            }}
          </h3>
        </v-card>
      </v-container> -->
  </div>
</template>

<script>
const Excel = require("exceljs");

export default {
  props: {
    data: Object,
    dates: Array,
    showExport: Boolean,
  },
  data() {
    return {
      tab: null,
      arrayData: [],
      voucherIndexReceipt: 0,
      voucherIndexExpenses: 0,
      receiptFiltered: [],
      expensesFiltered: [],
      receiptHeaders: [
        { text: "التسلسل", value: "index" },
        { text: "رقم الوصل", value: "idReceipt" },
        { text: "تاريخ الوصل", value: "receiptDateFormat" },
        { text: "نوع السند", value: "type" },
        { text: "المبلغ", value: "amount" },
        { text: "الملاحظات", value: "notes" },
      ],
      boxName: [
        { name: "اقساط للمراحل", id: 1 },
        { name: "الهويات", id: 2 },
        { name: "الاستمارات", id: 7 },
        { name: "تأييدات ووثائق", id: 4 },
        { name: "صحة صدور", id: 8 },
        { name: "سنوات سابقة", id: 5 },
        { name: "هويات حجز مقعد", id: 9 },
        { name: "اقساط حجز مقعد", id: 10 },
        { name: "خدمات جامعية للمراحل", id: 11 },
        { name: "اقساط المرحلة الاولى", id: 15 },
        { name: "هويات المرحلة الاولى", id: 16 },
        { name: "خدمات المرحلة الاولى", id: 18 },
        { name: "خدمات المرحلة الاولى", id: 21 },
        { name: "التعليم المستمر", id: 22 },
        { name: "الرواتب", id: 25 },
      ],
      headers: [
        { text: "التسلسل", value: "index" },
        { text: "رقم الوصل", value: "idExpenses" },
        { text: "تاريخ الوصل", value: "expensesDateFormat" },
        { text: "نوع السند", value: "typeName" },
        { text: "المبلغ", value: "amount" },
        { text: "الملاحظات", value: "notes" },
        { text: "بواسطة", value: "employeeName", width: 200 },
      ],
    };
  },
  created() {
    console.log("================================================================");
    console.log(this.data);
    console.log("================================================================");
    this.receiptFiltered = this.data.expenses.filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 12 && data.boxId != 13 && data.boxId != 14 && data.boxId != 26);
    this.expensesFiltered = this.data.receipt.filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 12 && data.boxId != 13 && data.boxId != 14 && data.boxId != 26);
    this.data.expenses = this.data.expenses.filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 12 && data.boxId != 13 && data.boxId != 14 && data.boxId != 21 && data.boxId != 26);
    this.data.receipt = this.data.receipt.filter(
      (data) =>
        data.boxId != 9 &&
        data.boxId != 11 &&
        data.receiptTypeId != 8 &&
        data.receiptTypeId != 5 &&
        data.boxId != 11 &&
        data.boxId != 12 &&
        data.boxId != 13 &&
        data.boxId != 14 &&
        data.boxId != 21 &&
        data.boxId != 26
    );
  },

  methods: {
    exportExcel() {
      let self = this;
      const workbook = new Excel.Workbook();

      let mainBox = self.receipt.filter((data) => data.boxId == 1 || data.boxId == 5 || data.boxId == 8);
      let identityBox = self.receipt.filter((data) => data.boxId == 2);
      let certificateBox = self.receipt.filter((data) => data.boxId == 7);
      let newData = [mainBox, identityBox, certificateBox];
      console.log(newData);

      newData.forEach((data, index) => {
        let name = self.getSheetName(index);
        const worksheet = workbook.addWorksheet(name);
        worksheet.views = [{ rightToLeft: true }];

        worksheet.columns = [
          { header: "رقم الوصل", key: "expensesNumber", width: 15 },
          { header: "تاريخ الوصل", key: "expensesDate", width: 50 },
          { header: "نوع السند", key: "type", width: 50 },
          { header: "المبلغ", key: "amount", width: 20 },
          { header: "الملاحظات", key: "notes", width: 50 },
          { header: "بواسطة", key: "createdBy", width: 50 },
        ];

        data.forEach((expenses) => {
          worksheet.addRow({
            expensesNumber: expenses.idExpenses,
            expensesDate: expenses.expensesDateFormat,
            type: expenses.typeName,
            amount: expenses.amount,
            notes: expenses.notes,
            createdBy: expenses.employeeName,
          });
        });

        worksheet.eachRow(function (row, rowNumber) {
          row.eachCell((cell) => {
            cell.alignment = { vertical: "middle", horizontal: "center" };
          });
        });

        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.fill = {
            type: "pattern",
            pattern: "darkTrellis",
            fgColor: { argb: "FFFFFF00" },
            bgColor: { argb: "FF0000FF" },
          };
        });
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        a.download = `expensesReport.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    },
    printReport() {
      let self = this;
      const WinPrint = window.open("", "", "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0");
      WinPrint.document.write(`<!DOCTYPE html>
        <!DOCTYPE html>
          
        <html lang="ar">
        <style>
         
        @media print {
          @page { margin: 0.5cm !important; }
          
          .pagebreak {
            clear: both;page-break-after: always;
          }
          table { page-break-inside:auto }
          tr    { page-break-inside:avoid; page-break-after:auto }
        }
          body {
            direction : rtl !important;
          }
          table {
            width : 98% !important;
          }
          tr,tr td,th{
            text-align : center !important;
            font-size : 12px !important;
            padding : 5px !important;
          }
        </style>
        <body>
              ${self.printTableDataReceipt()}
              <h5 style="padding: 20px; font-size: 12px">
              المجموع الكلي للواردات :
              ${self.data.receipt
                .filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 36)
                .reduce((n, { amount }) => n + amount, 0)
                .toLocaleString("en-US")}
            </h5>
            
            <div style="page-break-after: always;"></div>
            ${self.printTableDataExpenses()}
              <h5 style="padding: 20px; font-size: 12px">
              المجموع الكلي للصرفيات :
              ${self.data.expenses
                .filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 14)
                .reduce((n, { amount }) => n + amount, 0)
                .toLocaleString("en-US")}
            </h5>

        </body>`);

      self.voucherIndexReceipt = 0;
      self.voucherIndexExpenses = 0;
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    },

    getTotalMoney(arrayOfData) {
      if (arrayOfData) {
        let total = arrayOfData.reduce((n, { amount }) => n + amount, 0);
        return total;
      } else {
        return 0;
      }
    },
    sliceArrayPrint(arrayOfData) {
      let begin = 0;
      let end = 17;
      let newArray = [];
      let numberOfIteration = Math.ceil(arrayOfData.length / 17);
      console.log(Math.ceil(arrayOfData.length / 17));

      for (let i = 0; i < numberOfIteration; i++) {
        newArray.push(arrayOfData.slice(begin, end * (i + 1)));
        begin += 17;
      }
      return newArray;
    },
    printTableDataReceipt() {
      let self = this;
      let tableData = "";
      let receiptData = self.data.receipt;
      let dataPrint = self.sliceArrayPrint(receiptData.reverse());

      for (let i = 0; i < dataPrint.length; i++) {
        tableData += `
        <h4 style="text-align:center">${self.dates[0]} / ${self.dates[1]}</h4>
        <table border='1' style="padding:3px;margin: 5px auto !important;">
            <tr>
                <th>التسلسل</th>
                <th>رقم الوصل</th>
                <th>تاريخ الوصل</th>
                <th>من الصندوق</th>
                <th>نوع السند</th>
                <th>المبلغ</th>
                <th colspan="4">الملاحظات</th>
              </tr>
              ${self.rowTableReceipt(dataPrint[i])}
          </table>
          
          <h5 style="padding: 10px; font-size: 12px">
              المجموع :
              ${self.getTotalMoney(dataPrint[i]).toLocaleString("en-US")}
            </h5>
            ${i == dataPrint.length - 1 ? "" : '<div style=" clear: both;page-break-after: always;"></div><div style="clear:both!important;"/> </div>'}
          `;
      }
      return tableData;
    },
    rowTableReceipt(arrayOfData) {
      let self = this;
      let tdData = "";
      for (let j = 0; j < arrayOfData.length; j++) {
        self.voucherIndexReceipt += 1;
        tdData += `
              <tr>
                <td>${self.voucherIndexReceipt}</td>
                <td>${arrayOfData[j].idReceipt}</td>
                <td>${arrayOfData[j].receiptDateFormat}</td>
                <td>${arrayOfData[j].employeeName}</td>
                <td>${arrayOfData[j].typeName}</td>
                
                <td style="font-size:12px">${arrayOfData[j].amount.toLocaleString("en-US")}</td>
                <td  colspan="4"> ${arrayOfData[j].notes}</td>
              </tr>
          `;
      }
      return tdData;
    },

    printTableDataExpenses() {
      let self = this;
      let tableData = "";
      let receiptData = self.data.expenses.filter((data) => data.boxId != 9 && data.boxId != 11 && data.boxId != 12 && data.boxId != 13 && data.boxId != 14 && data.boxId != 26);
      let dataPrint = self.sliceArrayPrint(receiptData.reverse());

      for (let i = 0; i < dataPrint.length; i++) {
        tableData += `
        <h3 style="text-align:center">${self.dates[0]} / ${self.dates[1]}</h3>
        <table border='1' style="padding:3px;margin: auto !important;">
            <tr>
                <th>التسلسل</th>
                <th>رقم الوصل</th>
                <th>تاريخ الوصل</th>
                <th>من الصندوق</th>
                <th>نوع السند</th>
                <th>المبلغ</th>
                <th colspan="4">الملاحظات</th>
              </tr>
              ${self.rowTableExpenses(dataPrint[i])}
          </table>
          
          <h5 style="padding: 10px; font-size: 12px">
              المجموع :
              ${self.getTotalMoney(dataPrint[i]).toLocaleString("en-US")}
            </h5>
            ${i == dataPrint.length - 1 ? "" : '<div style=" clear: both;page-break-after: always;"></div><div style="clear:both!important;"/> </div>'}
          `;
      }
      return tableData;
    },
    rowTableExpenses(arrayOfData) {
      let self = this;
      let tdData = "";
      for (let j = 0; j < arrayOfData.length; j++) {
        self.voucherIndexExpenses += 1;
        tdData += `
              <tr>
                <td>${self.voucherIndexExpenses}</td>
                <td>${arrayOfData[j].idExpenses}</td>
                <td>${arrayOfData[j].expensesDateFormat}</td>
                <td>${arrayOfData[j].boxName}</td>
                <td>${arrayOfData[j].typeName}</td>
                
                <td style="font-size:12px">${arrayOfData[j].amount.toLocaleString("en-US")}</td>
                <td  colspan="4"> ${arrayOfData[j].notes}</td>
              </tr>
            
          `;
      }
      return tdData;
    },
    getSheetName(index) {
      switch (index) {
        case 0:
          return "الصندوق الرئيسي";
        case 1:
          return "صندوق الهويات";
        case 2:
          return "صندوق الاستمارات";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
tr,
tr td {
  text-align: center !important;
  padding: 3px !important;
}
</style>
